export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

export const GOOGLE_MAPS_LOADER_ID = "google-map-script";

// Use one shared library list everywhere to avoid loader option conflicts.
export const GOOGLE_MAPS_LIBRARIES = ["places", "drawing"];

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: GOOGLE_MAPS_LOADER_ID,
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
  language: "en",
  region: "US",
};
